import BaseService from './base-service.js'
const baseUrlCustomers = '/customers/bo'

export default {
    async getStoreVisitors({ storeId }) {
        const { data } = await BaseService.get(
            `${baseUrlCustomers}/storeVisitors/${storeId}`
        )

        return data
    },
}
